import { useTranslation } from "@/hooks/useTranslation";
import { Route } from "@/routes/st-admin/payments/index";
import { Icon, TabItem, Tabs, TabsList, Typography } from "@st-marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import { CommissionSummaryTable } from "./CommissionSummaryTable";
import { PaymentsTable } from "./PaymentsTable";

type PaymentsTab = "commission" | "marketplace";

const STAdminPayments = () => {
	const { t } = useTranslation();
	const navigate = useNavigate({ from: "/st-admin/payments" });
	const { tab = "commission" } = Route.useSearch();

	return (
		<div className="flex flex-col gap-6">
			<Typography variant="title-md" as="h1">
				{t("admin.payments.title")}
			</Typography>

			<Tabs
				value={tab}
				onValueChange={(value) =>
					navigate({ search: { tab: value as PaymentsTab }, replace: true })
				}
			>
				<TabsList className="overflow-x-auto">
					<TabItem value="commission" Icon={<Icon name="percent-line" />}>
						{t("admin.payments.commissionTab")}
					</TabItem>
					<TabItem value="marketplace" Icon={<Icon name="exchange-line" />}>
						{t("admin.payments.marketplaceTab")}
					</TabItem>
				</TabsList>
			</Tabs>

			{tab === "commission" ? (
				<>
					<CommissionSummaryTable />
					<Typography variant="title-sm" as="h2">
						{t("admin.payments.commissionPayments")}
					</Typography>
					<PaymentsTable key="system" paymentType="system" />
				</>
			) : (
				<PaymentsTable key="market" paymentType="market" />
			)}
		</div>
	);
};

export default STAdminPayments;
